/**
 * Erreurs liées aux subscriptions et aux licences
 */

import { ERROR_CODES } from '@repo/contracts/errors';

import { ErrorConfigWithCallback } from './types';

export const SUBSCRIPTION_ERRORS: Record<string, ErrorConfigWithCallback> = {
    [ERROR_CODES.NOT_FOUND]: {
        messageKey: 'license-changes-detected-for-this-user-available-licenses-list-refreshed',
        severity: 'error',
        callbackable: true,
        callbackDescription: 'Rafraîchit les données des licences utilisateur et ferme le modal d\'affectation',
    },
    [ERROR_CODES.ALREADY_ASSIGNED]: {
        messageKey: 'license-changes-detected-for-this-user-available-licenses-list-refreshed',
        severity: 'error',
        callbackable: true,
        callbackDescription: 'Rafraîchit les données des licences utilisateur et ferme le modal d\'affectation',
    },
    [ERROR_CODES.COMMITMENT_CHANGE_ALREADY_IN_PROGRESS]: {
        messageKey: 'commitment-change-already-in-progress',
        severity: 'error',
        callbackable: true,
        callbackDescription: 'Rafraîchit les données et ferme le modal de confirmation de changement d\'engagement',
    },
    [ERROR_CODES.NO_VALID_SUBSCRIPTION]: {
        messageKey: 'no-active-subscription-for-this-module',
        severity: 'error',
    },
};
